import React from "react";

type Props = {
  visitStatus?: string;
  accessUpdatedAt?: string | null;
  isDeleted?: boolean;
};

// 방문상태

export const getVisitStatusV2Label = (props: Props): string => getDisplay(props).label;

const getDisplay = ({ visitStatus, accessUpdatedAt, isDeleted }: Props) => {
  if (isDeleted || visitStatus === "VISIT_DELETE") {
    return { label: "방문취소", className: "status H" };
  }

  const hasAccessRecord = !!accessUpdatedAt;

  switch (visitStatus) {
    case "VISIT_PENDING":
      return { label: "신청완료", className: "status E" };
    case "VISIT_USE":
      return hasAccessRecord
        ? { label: "방문중", className: "status F" }
        : { label: "방문예정", className: "status F" };
    case "VISIT_CLOSE":
      return hasAccessRecord
        ? { label: "방문완료", className: "status H" }
        : { label: "미방문", className: "status H" };
    default:
      return { label: "-", className: "" };
  }
};

const VisitStatusTagV2 = (props: Props) => {
  const { label, className } = getDisplay(props);

  return (
    <div
      className={className}
      style={{
        minWidth: 52,
        maxWidth: 52,
        padding: "4px 0",
        display: "flex",
        justifyContent: "center",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </div>
  );
};

export default VisitStatusTagV2;
